<div [class.dark-theme]="true" class="fix-action-dialog">
	<div class="fix-action-dialog">
		<h2 data-idtest="aigia-password-dialog-t-8Bi" mat-dialog-title style="font-size: 14px;color:#fdfdfd;font-weight: 600;">{{content.title | translate}}</h2>
	</div>
	<mat-dialog-content fxLayout="column">
		<mat-card>
			<mat-card-content>
				<p data-idtest="aigia-password-dialog-t-5Ba" class="card-title">{{content.description | translate}}</p>
				<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
					<div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="space-between">
						<mat-form-field appearance="outline" fxFlex="100" style="height: 80px;">
							<!-- <mat-label>メールアドレス</mat-label> -->
							<input data-idtest="aigia-password-dialog-i-4Sf" #username="ngModel" [(ngModel)]="content.username" autocomplete="off" email matInput maxlength="255" minlength="3" name="username" placeholder="{{'メールアドレス' | translate}}" required type="email">
							<!-- <div class="error-text" style="padding-left:32%;" [ngStyle.lt-md]='{"padding-left":"0%"}' fxFlex="100%"> -->
							<mat-error *ngIf="username.errors?.['email'];"><span translate>有効なメールアドレスで</span></mat-error>
							<mat-error *ngIf="username.errors?.['required'];"><span translate>入力してください</span></mat-error>
							<mat-error *ngIf="username.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
							<mat-error *ngIf="username.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
							<!-- </div> -->
						</mat-form-field>
					</div>
					<div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="space-between">
						<mat-form-field appearance="outline" fxFlex="100" style="height: 80px;">
							<!-- <mat-label>パスワード</mat-label> -->
							<input data-idtest="aigia-password-dialog-i-0Ui" #password="ngModel" [(ngModel)]="content.password" matInput maxlength="1000" minlength="6" name="password" placeholder="{{'パスワード' | translate}}" required type="password">
							<mat-hint><span data-idtest="aigia-password-dialog-t-2Wg" translate>6文字以上1000文字まで</span></mat-hint>
							<!-- <div class="error-text" style="padding-left:32%;" [ngStyle.lt-md]='{"padding-left":"0%"}' fxFlex="100%"> -->
							<mat-error *ngIf="password.errors?.['required'];"><span translate>入力してください</span></mat-error>
							<mat-error *ngIf="password.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
							<mat-error *ngIf="password.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
							<!-- </div> -->
						</mat-form-field>

					</div>
					<div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="space-between">
						<mat-form-field appearance="outline" fxFlex="100" style="height: 80px;">
							<!-- <mat-label>確認のためパスワードを再度ご入力ください。</mat-label> -->
							<input data-idtest="aigia-password-dialog-i-6Rh" #confirm_password="ngModel" [(ngModel)]="content.confirm_password" [validateEquals]="password" matInput name="confirm_password" placeholder="{{'パスワード(確認)' | translate}}" required type="password">
							<mat-hint><span data-idtest="aigia-password-dialog-t-3Gv" translate>6文字以上1000文字まで</span></mat-hint>
							<!-- <div class="error-text" style="padding-left:32%;" [ngStyle.lt-md]='{"padding-left":"0%"}' fxFlex="100%"> -->
							<mat-error *ngIf="confirm_password.errors?.['required'];"><span translate>確認用パスワードを入力してください</span></mat-error>
							<mat-error *ngIf="confirm_password.errors?.['validateEquals']"><span translate>確認用パスワードが一致しません</span></mat-error>
							<!-- </div> -->
						</mat-form-field>
					</div>
				</form>
			</mat-card-content>
		</mat-card>
	</mat-dialog-content>

	<div class="spacer"></div>

	<mat-dialog-actions fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around" style="margin:6px;">
		<div fxFlex="50%" fxFlex.lt-sm="100%" fxLayoutAlign="center">
			<button [disabled]="isProgress" color="warn" mat-dialog-close="" mat-stroked-button fxFlex="50%" fxFlex.lt-sm="100%"><span data-idtest="aigia-password-dialog-t-1Oo" translate>キャンセル</span></button>
		</div>
		<div fxFlex="50%" fxFlex.lt-sm="100%" fxLayoutAlign="center">
			<button data-idtest="aigia-password-dialog-b-3Sc" (click)="onAccept()" *ngIf="!(form.invalid || isProgress)" [disabled]="form.invalid || isProgress" color="primary" mat-raised-button fxFlex="50%" fxFlex.lt-sm="100%"><span data-idtest="aigia-password-dialog-t-8Xn" translate>送信</span></button>
			<button *ngIf="( form.invalid || isProgress)" [disabled]="form.invalid || isProgress" color="primary" mat-raised-button fxFlex="50%" fxFlex.lt-sm="100%"><span data-idtest="aigia-password-dialog-t-4Lq" translate>送信</span></button>
		</div>
	</mat-dialog-actions>
</div>
